<template>
  <div class="summary-tooltip-wrapper">
    <span class="summary-tooltip-overlay" @click="$emit('close')"></span>
    <div
      class="summary-ia summary-tooltip-content"
      :class="color"
      ref="tooltip"
    >
      <span class="summary-tooltip-arrow" ref="arrow"></span>
      <div class="summary-ia-button-wrapper">
        <div type="button" class="summary-ia-button">
          <span
            role="button"
            aria-label="Close tooltip"
            class="icon"
            @click="$emit('close')"
          >
            <i v-icon:close-x></i>
          </span>
        </div>
      </div>
      <div class="summary-ia-region-wrapper">
        <div class="summary-ia-region-content">
          <div class="summary-ia-region-info" v-html="safeHtml"></div>
          <!-- <div ref="typing" class="summary-ia-region-info"></div> -->
          <!-- <div class="summary-ia-region-likes">
            <span>Valora este resumen</span>
            <button><i v-icon:like></i></button>
            <button><i v-icon:dislike></i></button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computePosition,
  flip,
  shift,
  arrow,
  autoUpdate,
  offset,
} from "@floating-ui/dom";
import showdown from "showdown";

export default {
  name: "VSummaryAccordion",
  props: {
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "geb",
    },
  },
  destroyed() {
    this.clearup();
  },
  data() {
    return {
      typed: null,
      clearup: null,
      converter: new showdown.Converter({
        parseHtml: false,
        simpleLineBreaks: true,
        noHeaderId: true,
        ghCompatibleHeaderId: false,
      }),
    };
  },
  computed: {
    safeHtml() {
      const plainHtml = this.converter.makeHtml(this.content);
      return plainHtml
        .replace(/<\/p>\s*<p>/g, "\n\n")
        .replace(/<br\s*\/?>/g, "\n")
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/\n\n/g, "</p><p>")
        .replace(/\n/g, "<br>")
        .replace(/^(.+)$/, "<p>$1</p>")
        .trim();
    },
  },
  mounted() {
    document.body.insertBefore(this.$el, null);
    // this.typed = new Typed(this.$refs["typing"], {
    //   strings: [this.content],
    //   typeSpeed: 1,
    //   showCursor: false,
    // });
    this.typed = this.content;
    const button = this.$parent.$refs["button"];
    const tooltip = this.$refs["tooltip"];
    this.updateTooltip();
    this.clearup = autoUpdate(button, tooltip, this.updateTooltip);
  },
  methods: {
    updateTooltip() {
      const button = this.$parent.$refs["button"];
      const tooltip = this.$refs["tooltip"];
      const element = this.$refs["arrow"];
      computePosition(button, tooltip, {
        placement: "top",
        middleware: [offset(20), flip(), shift(), arrow({ element })],
      }).then((res) => {
        const { x, y, placement, middlewareData } = res;
        const staticSide = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right",
        }[placement.split("-")[0]];

        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });

        const { x: arrowX, y: arrowY } = middlewareData.arrow;

        Object.assign(element.style, {
          left: arrowX != null ? `${arrowX}px` : "",
          top: arrowY != null ? `${arrowY}px` : "",
          right: "",
          bottom: "",
          [staticSide]: "-16px",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
